'use strict';
const angular = require('angular');

/*@ngInject*/
export function BankingAccountsService($resource) {
  return $resource('/api/banking-accounts/:id', {
    name: '@_id'
  },{
    getByUser: {
      method: 'GET',
      url: "/api/banking-accounts/user/me",
      isArray: true
    },
    getPaymentsByUser: {
      method: 'GET',
      url: "/api/banking-accounts/payments/user/me",
      isArray: true
    },
    update: {
      method: 'PUT'
    },
    delete: {
      method: 'DELETE',
      url: "/api/banking-accounts/customer/:customer/:id",
    },
    verify: {
      method: 'POST',
      url: "/api/banking-accounts/verify/:customer/:id",
    }
  });
}


export default angular.module('conduuApp.BankingAccountsService', [])
  .factory('BankingAccountsService', BankingAccountsService)
  .name;



// WEBPACK FOOTER //
// ./client/services/banking-accounts/banking-accounts.service.js